export const ACTIVE = 1;
export const PAUSED = 2;
export const DELETED = 3;
export const INACTIVE = 4;
export const CAMPAIGN_PAUSED = 5;
export const SET_PAUSED = 6;
